import React from "react";
import "./UpcommingStocks.scss";
import {MDBProgress} from "mdbreact";
import {Fade} from 'react-reveal'
import BottomModal from "../BottomModal/BottomModal";
import cogoToast from "cogo-toast";
import CreateOrderMutation from "../../mutations/CreateOrderMutation";
import OrderConfirmation from "../OrderConfirmation/OrderConfirmation";
import PinVerification from "../PinVerification/PinVerification";
import Loading from "../Loading";
import {Link, withRouter} from "react-router-dom";
import PreBookStock from "./PreBookStock";
import DetailPageModalFooter from "../DetailPageModalFooter/DetailPageModalFooter";
import ReactTooltip from "react-tooltip";
import Reveal from "react-reveal/Reveal";
import {numberFormat} from "../../util";
import {assetUrl} from "../../serviceApi";
import Skeleton from "react-loading-skeleton";
import {AddProfileData, setActivePage} from "../../Actions";
import {compose} from "redux";
import {connect} from "react-redux";
import Login from "../../pages/Login/Login";

const ProfileIcon = assetUrl + "images/profile-icon.svg";
const StockClock = assetUrl + "images/stock-clock.svg";

class UpcommingStocks extends React.Component {
	state = {
		open_modal: false,
		selected_stock: {},
		quantity: 1,
		completed_action: "",
		order_failed: false,
		orderMode: "Market_Order",
		pin: "",
		full_height_modal: false,
		loading: false,
		limit_order_price: 0,
		selected_action: "buy",
		login_modal:false
	}
	openModal = (item) => {
		this.setState({
			open_modal: true,
			selected_stock: item,
			selected_action: "buy"
		});
	}
	closeModal = () => {
		this.setState({
			open_modal: false,
			selected_stock: {},
			quantity: 1,
			pin: "",
			selected_action: "buy"
		});
	}
	openFullHeightModal = (action) => {
		this.setState({
			full_height_modal: true,
		});
	}
	closeFullHeightModal = () => {
		this.setState({
			full_height_modal: false,
			quantity: 1,
			pin: ""
		});
	}

	prebookStock = () => {
		if (this.state.quantity === "" || this.state.quantity < 1) {
			cogoToast.error("Please fill valid quantity", {position: 'top-center'});
		} else {
			this.openFullHeightModal();
		}
	}

	handlePinInputChange = (e) => {
		this.setState({
			pin: (e.target.validity.valid) ? e.target.value : this.state.pin
		})
	}
	handleRadioInputs = (data) => {
		this.setState({
			orderMode: data
		});
	}
	handleQtyChange = (e) => {
		this.setState({
			quantity: e.target.value
		});
	}
	createOrder = () => {
		let variable = {
			stockId: this.state.selected_stock.id,
			quantity: this.state.quantity,
			orderMode: this.state.orderMode,
			orderType: "Buy",
			userPin: this.state.pin,
		}
		let scope = this;
		if (this.state.pin === "" || this.state.pin < 4) {
			cogoToast.error("Please fill valid pin", {position: 'top-center'});
		} else {

			this.updateLoading(true);

			CreateOrderMutation(variable, function (response) {
				scope.updateLoading(false);
				if (response.createOrder.order.id) {
					scope.setState({
						completed_action: scope.state.selected_action,
						selected_action: "",
						// quantity:0,
						pin: "",
						order_failed: false,
						full_height_modal: false,
					})
				}
			}, function (err) {
				scope.updateLoading(false);
				cogoToast.error(err, {position: 'top-center'});
			});
		}
	}

	updateLoading = (action) => {
		this.setState({
			loading: action
		})
	}
	checkUserLoggedIn = (data) => {
		if(this.props.logged_in === false){
			this.openLoginModal();
		} else {
			this.openModal(data);
		}
	}
	openLoginModal = () => {
		this.setState({
			login_modal:true
		});
	}
	closeLoginModal = () => {
		this.setState({
			login_modal:false
		});
	}
	completeLogin = () => {
		this.closeLoginModal();
		window.location.reload();
		// this.getWalletData();
	}
	render() {
		const {stock_data} = this.props;
		return (
			<div>
				{/*<ReactTooltip place={"bottom"} multiline={true} data-class={"test-class"}/>*/}
				{/*<p data-tip="hello worlsssssssssssssssssssssssssssssssssssssssssssssssd">Tooltip</p>*/}
				{/*<Loading loading={this.state.loading}>*/}
					<div className={"upcomming-stocks-component"}>

						{
							!this.props.Componentloading ?

								stock_data.length > 0 ?
									stock_data.map((item, index) => {

										return (
											<div key={index}>
												{/*<Reveal effect="fadeInUp">*/}
												<div>

													<div className={"d-flex justify-content-between"}>
														<Link to={"/stock-detail/" + item.node.id}>
															<div className={"d-flex"}>
																<div className={"profile-section"}>
																	<img
																		src={item.node.politicianImage ? item.node.politicianImage : ProfileIcon}
																		alt={"StockProfile"}
																		className={"img-fluid stock-profile"}/>

																	<img src={StockClock} alt={"StockClock"}
																	     className={"clock-image"}/>
																</div>
																<div className={"stock-description"}>
																	<p className={"stock-name"}>{item.node.name}</p>
																	<p className={"party-name"}>{item.node.party ? item.node.party.partyName : ""}</p>
																</div>
															</div>
														</Link>
														<div className={"text-right"}>
															<p className={"stock-price text-right"}>{numberFormat(item.node.price)}</p>
															<a className={"pre-book text-right"}
															   onClick={()=>this.checkUserLoggedIn(item.node)}
															   // onClick={() => this.openModal(item.node)}
															>Subscribe</a>
														</div>
													</div>
													<p className={"stock-left mb-2"}><span
														style={{fontWeight: 700}}>{item.node.upcomingStocksSubscribed}/{item.node.upcomingStocks}</span>{item.node.upcomingStocksSubscribed > 1 ? " Shares " : " Share "}
														Left</p>
													<Fade bottom>
														<div className={"progress-bg"}>
															<MDBProgress
																value={(100 - item.node.upcomingStocksPercentage)}
																className=""/>
														</div>
													</Fade>
													<hr className={"stock-divider"}/>

												</div>
												{/*</Reveal>*/}
											</div>

										);
									})
									: <div className={"error-section"}>No Datas Found</div>
								:
								<>
									<Skeleton count={3}/>
									<br/><br/>
									<Skeleton count={3}/>
									<br/><br/>
									<Skeleton count={3}/>
									<br/><br/>
								</>

						}

						<BottomModal
							title={this.state.selected_action === "buy" ? "Subscribe" : ""}
							isOpen={this.state.open_modal}
							closeModal={this.closeModal}
							removeHeader={false}
							footer={this.state.selected_action === "buy"}
							footerComponent={
								<DetailPageModalFooter
									limit_order_price={this.state.limit_order_price}
									stock_data={this.state.selected_stock}
									order_mode={this.state.orderMode}
									submit={this.prebookStock}
									buttonText={"Subscribe"}
									quantity={this.state.quantity}
								/>
							}
						>
							{
								this.state.selected_action === "buy" ?
									<PreBookStock
										selected_stock={this.state.selected_stock}
										submit={this.prebookStock}
										handleRadioInputs={this.handleRadioInputs}
										order_mode={this.state.orderMode}
										handleQtyChange={this.handleQtyChange}
										quantity={this.state.quantity}
									/> :
									<OrderConfirmation
										quantity={this.state.quantity}
										completed_action={this.state.completed_action}
										order_failed={this.state.order_failed}
										stock_data={this.state.selected_stock}
										submit={this.createOrder}
									/>
							}

						</BottomModal>
						{/*<FullPageModal*/}
						{/*    isOpen={this.state.full_height_modal}*/}
						{/*    closeModal={this.closeFullHeightModal}>*/}
						{/*    {*/}
						<PinVerification
							submit={this.createOrder}
							handlePinInputChange={this.handlePinInputChange}
							pin={this.state.pin}
							selected_action={"buy"}
							stock_data={this.state.selected_stock}
							quantity={this.state.quantity}
							order_mode={this.state.orderMode}
							limit_order_price={this.state.limit_order_price}
							isOpen={this.state.full_height_modal}
							closeModal={this.closeFullHeightModal}
						/>
						{/*    }*/}
						{/*</FullPageModal>*/}
					</div>
				{/*</Loading>*/}
				<Login isOpen={this.state.login_modal}
					   closeModal={this.closeLoginModal}
					   completeLogin={this.completeLogin}
				/>
			</div>

		);
	}
}


const mapStateToProps = state => ({
	logged_in: state.UserReducer.logged_in
})

export default compose(
	withRouter,
	connect(mapStateToProps, null)
)(UpcommingStocks)





